// extracted by mini-css-extract-plugin
export default {"overlay":"Screensaver_overlay__yaePY","screensaverIn":"Screensaver_screensaverIn__OQOzb","logo":"Screensaver_logo__wpJdR"};